/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 176:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(177);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _qty_selector__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(178);


var selectors = {
  variantSelector: '[data-product-select]',
  decrementQtyBtn: '[data-decrement-qty]',
  incrementQtyBtn: '[data-increment-qty]',
  qtyInput: '[data-qty-input]',
  addButton: '.product-card__add',
  addedLabel: '.product-card__added',
  noSide: '.no-side-cart'
};
var cssClasses = {
  show: 'show'
};

function ProductCard(container) {
  var _variantSelector$opti;

  var variantSelector = container.querySelector(selectors.variantSelector);
  var qtyInput = container.querySelector(selectors.qtyInput);
  if (!variantSelector || !qtyInput) return;
  var selectedVariantId = (_variantSelector$opti = variantSelector.options[variantSelector.selectedIndex]) === null || _variantSelector$opti === void 0 ? void 0 : _variantSelector$opti.value;
  (0,_qty_selector__WEBPACK_IMPORTED_MODULE_1__.default)(container.querySelector(selectors.decrementQtyBtn), container.querySelector(selectors.incrementQtyBtn), container.querySelector(selectors.qtyInput));
  container.addEventListener('click', function (evt) {
    var _window$sideCart;

    var target = evt.target;
    var addButton = target.closest(selectors.addButton);
    if (!addButton || addButton.disabled) return;
    evt.preventDefault();
    var addedLabel = container.querySelector(selectors.addedLabel);
    var noSideCart = container.querySelector(selectors.noSide);
    var item = {
      id: selectedVariantId,
      quantity: qtyInput.value
    };
    (_window$sideCart = window.sideCart) === null || _window$sideCart === void 0 ? void 0 : _window$sideCart.handleAddToCartEvent(item, !noSideCart);
    addedLabel === null || addedLabel === void 0 ? void 0 : addedLabel.classList.add(cssClasses.show);
    setTimeout(function () {
      addedLabel === null || addedLabel === void 0 ? void 0 : addedLabel.classList.remove(cssClasses.show);
    }, 2000);
  });
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductCard);

/***/ }),

/***/ 178:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(179);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__);


var qtySelector = function qtySelector(decrementBtn, incrementBtn, input) {
  if (!decrementBtn || !incrementBtn || !input) return;
  var inputMin = Number(input.getAttribute('min'));
  decrementBtn.addEventListener('click', function () {
    var newQty = Number(input.value) - 1;

    if (newQty <= 0) {
      return;
    }

    input.value = Number(newQty);
    input.dispatchEvent(new Event('change'));

    if (newQty <= inputMin) {
      decrementBtn.setAttribute('disabled', '');
    }
  });
  incrementBtn.addEventListener('click', function () {
    var newQty = Number(input.value) + 1;
    input.value = Number(newQty);
    input.dispatchEvent(new Event('change'));

    if (newQty > inputMin) {
      decrementBtn.removeAttribute('disabled');
    }
  });
  input.addEventListener('input', function () {
    if (input.value <= inputMin) {
      decrementBtn.setAttribute('disabled', '');
    } else {
      decrementBtn.removeAttribute('disabled');
    }
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (qtySelector);

/***/ }),

/***/ 204:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(132);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(135);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(123);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(124);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(184);
/* harmony import */ var core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(102);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(205);
/* harmony import */ var core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_from_entries_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(207);
/* harmony import */ var core_js_modules_es_object_from_entries_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_from_entries_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(208);
/* harmony import */ var core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(209);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(138);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(210);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var range_slider_wc__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(212);
/* harmony import */ var _utils_debounce__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(196);
/* harmony import */ var _utils_search_params__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(213);
/* harmony import */ var _product_card__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(176);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }





















var selectors = {
  collectionNavbar: '[data-collection-navbar]',
  collectionGrid: '[data-collection-grid]',
  productCard: '.product-card',
  pagination: '[data-collection-pagination]',
  filterToggle: '[data-collection-filter-toggle]',
  filterList: '[data-collection-filter-list]',
  filterDrawer: '[data-collection-filter-drawer]',
  filterContent: '[data-collection-filter-content]',
  filterClearLink: '[data-collection-filter-clear-link]',
  filterPriceRangeSlider: '[data-collection-filter-price-range-slider]',
  filterPriceRangeMin: '[data-collection-filter-price-range-min]',
  filterPriceRangeMax: '[data-collection-filter-price-range-max]',
  filterFooter: '[data-collection-filter-footer]',
  sortContainer: '[data-collection-sort]',
  sortToggle: '[data-collection-sort-toggle]',
  sortDropdown: '[data-collection-sort-dropdown]'
};
var cssClasses = {
  filterIsVisible: 'filter-is-visible',
  sortIsVisible: 'sort-is-visible',
  hide: 'hide'
};

var ResultsFilterSort = function ResultsFilterSort(container, id) {
  var defaultSortBy = container.dataset.defaultSortBy || 'manual';
  var collectionGrid = container.querySelector(selectors.collectionGrid);
  var collectionNavbar = container.querySelector(selectors.collectionNavbar);
  initProductCards();
  initNavbar();

  function initProductCards() {
    var productCards = container.querySelectorAll(selectors.productCard);
    productCards.forEach(function (product) {
      return (0,_product_card__WEBPACK_IMPORTED_MODULE_20__.default)(product);
    });
  }

  function initNavbar() {
    if (!collectionNavbar || !collectionGrid) return;
    var filterList = container.querySelector(selectors.filterList);
    var filterDrawer = container.querySelector(selectors.filterDrawer);
    var filterContent = container.querySelectorAll(selectors.filterContent);
    var filterFooter = container.querySelector(selectors.filterFooter);
    var pagination = container.querySelector(selectors.pagination);
    var sortDropdown = container.querySelectorAll(selectors.sortDropdown);

    var renderPage = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(searchParams) {
        var url, response, html, newDocument, filterListNew;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = "".concat(window.location.pathname, "?section_id=").concat(id, "&").concat(searchParams);
                _context.prev = 1;
                _context.next = 4;
                return fetch(url);

              case 4:
                response = _context.sent;

                if (!(response.ok === false)) {
                  _context.next = 7;
                  break;
                }

                throw new Error("Fetch \"".concat(id, "\" section response was not OK"));

              case 7:
                _context.next = 9;
                return response.text();

              case 9:
                html = _context.sent;
                newDocument = new DOMParser().parseFromString(html, 'text/html');
                collectionGrid.innerHTML = newDocument.querySelector(selectors.collectionGrid).innerHTML;

                if (filterList) {
                  filterListNew = newDocument.querySelector(selectors.filterList);
                  filterList.innerHTML = filterListNew.innerHTML; // Copy hidden state from new element

                  if (filterListNew.classList.contains(cssClasses.hide)) {
                    filterList.classList.add(cssClasses.hide);
                  } else {
                    filterList.classList.remove(cssClasses.hide);
                  }
                }

                if (sortDropdown) {
                  sortDropdown.forEach(function (content, index) {
                    var filterSortNew = newDocument.querySelector(selectors.sortDropdown);
                    content.innerHTML = filterSortNew.innerHTML;
                  });
                } // Replace each filter content separately so the accordion open/close state is saved


                if (filterContent) {
                  filterContent.forEach(function (content, index) {
                    var filterContentNew = newDocument.querySelectorAll(selectors.filterContent);
                    content.innerHTML = filterContentNew[index].innerHTML;
                  });
                }

                if (filterFooter) {
                  filterFooter.innerHTML = newDocument.querySelector(selectors.filterFooter).innerHTML;
                }

                if (pagination) {
                  pagination.innerHTML = newDocument.querySelector(selectors.pagination).innerHTML;
                }

                history.replaceState({
                  searchParams: searchParams
                }, '', "".concat(window.location.pathname).concat(searchParams && '?'.concat(searchParams)));
                initProductCards();
                initPriceRangeSlider();
                _context.next = 25;
                break;

              case 22:
                _context.prev = 22;
                _context.t0 = _context["catch"](1);
                window.console.error(_context.t0);

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 22]]);
      }));

      return function renderPage(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    var initRender = function initRender() {
      // render page to filter out redundant params
      var urlSearchParams = new URLSearchParams(window.location.search);
      var params = Object.fromEntries(urlSearchParams.entries());
      var stringParams = new URLSearchParams(params).toString();
      var keyValuePairsToRemove = [{
        key: 'sort_by',
        value: defaultSortBy
      }];
      var filterPriceRangeMin = container.querySelector(selectors.filterPriceRangeMin);

      if (filterPriceRangeMin) {
        keyValuePairsToRemove.push({
          key: filterPriceRangeMin.name,
          value: filterPriceRangeMin.min
        });
      }

      var filterPriceRangeMax = container.querySelector(selectors.filterPriceRangeMax);

      if (filterPriceRangeMax) {
        keyValuePairsToRemove.push({
          key: filterPriceRangeMax.name,
          value: filterPriceRangeMax.max
        });
      }

      var filteredSearchParams = (0,_utils_search_params__WEBPACK_IMPORTED_MODULE_19__.filterSearchParams)(stringParams, keyValuePairsToRemove);
      renderPage(filteredSearchParams);
    };

    initRender();

    var handleNavbarFormSubmit = function handleNavbarFormSubmit(event) {
      event.preventDefault();
      var formData = new FormData(event.target.closest('form'));
      var searchParams = new URLSearchParams(formData);
      var keyValuePairsToRemove = [{
        key: 'sort_by',
        value: defaultSortBy
      }];
      var filterPriceRangeMin = container.querySelector(selectors.filterPriceRangeMin);

      if (filterPriceRangeMin) {
        keyValuePairsToRemove.push({
          key: filterPriceRangeMin.name,
          value: filterPriceRangeMin.min
        });
      }

      var filterPriceRangeMax = container.querySelector(selectors.filterPriceRangeMax);

      if (filterPriceRangeMax) {
        keyValuePairsToRemove.push({
          key: filterPriceRangeMax.name,
          value: filterPriceRangeMax.max
        });
      }

      var filteredSearchParams = (0,_utils_search_params__WEBPACK_IMPORTED_MODULE_19__.filterSearchParams)(searchParams, keyValuePairsToRemove);
      renderPage(filteredSearchParams);
    };

    var debouncedNavbarFormSubmit = (0,_utils_debounce__WEBPACK_IMPORTED_MODULE_18__.debounce)(function (event) {
      handleNavbarFormSubmit(event);
    }, 1500);
    collectionNavbar.addEventListener('input', debouncedNavbarFormSubmit);
    collectionNavbar.addEventListener('submit', handleNavbarFormSubmit); // Filters

    if (filterDrawer) {
      var desktopQuery = window.matchMedia("(min-width: ".concat(window.theme.breakpoints.large, "px)"));

      var desktopQueryCallback = function desktopQueryCallback() {
        handleResize();
      }; // Check for `addEventListener` is required to support iOS and Safari <14.


      if (typeof (desktopQuery === null || desktopQuery === void 0 ? void 0 : desktopQuery.addEventListener) === 'function') {
        desktopQuery.addEventListener('change', desktopQueryCallback);
      } else {
        desktopQuery.addListener(desktopQueryCallback);
      } // Toggle filters drawer


      var handleFilterToggles = function handleFilterToggles(event) {
        var filterToggle = event.target.closest(selectors.filterToggle);
        if (!filterToggle) return;

        if (document.body.classList.contains(cssClasses.filterIsVisible)) {
          document.body.classList.remove(cssClasses.filterIsVisible);
        } else {
          document.body.classList.add(cssClasses.filterIsVisible);
        }
      };

      collectionNavbar.addEventListener('click', handleFilterToggles);
    }

    if (filterContent) {
      // Clear filters links
      var handleClearFiltersLinkClick = function handleClearFiltersLinkClick(event) {
        var _filterClearLink$href;

        var filterClearLink = event.target.closest(selectors.filterClearLink);
        if (!filterClearLink) return;
        event.preventDefault();
        var searchParams = (_filterClearLink$href = filterClearLink.href.split('?')[1]) !== null && _filterClearLink$href !== void 0 ? _filterClearLink$href : '';
        renderPage(searchParams);
      };

      collectionNavbar.addEventListener('click', handleClearFiltersLinkClick); // Price range filter

      initPriceRangeSlider();
    } // Toggle sort dropdown


    var sortToggle = container.querySelectorAll(selectors.sortToggle);

    var handleToggleSort = function handleToggleSort() {
      document.body.classList.toggle(cssClasses.sortIsVisible);
    };

    if (sortToggle) {
      sortToggle.forEach(function (toggle) {
        toggle.addEventListener('click', handleToggleSort);
      });
    } // Close sort dropdown when you click outside


    document.addEventListener('click', function (event) {
      var isSortActive = document.body.classList.contains(cssClasses.sortIsVisible);
      if (!isSortActive) return;
      var isSortBy = Boolean(event.target.closest(selectors.sortContainer));
      if (isSortBy) return;
      document.body.classList.remove(cssClasses.sortIsVisible);
    });
  }

  function handleResize() {
    document.body.classList.remove(cssClasses.filterIsVisible);
  }

  function initPriceRangeSlider() {
    var filterPriceRangeSlider = container.querySelector(selectors.filterPriceRangeSlider);
    var filterPriceRangeMin = container.querySelector(selectors.filterPriceRangeMin);
    var filterPriceRangeMax = container.querySelector(selectors.filterPriceRangeMax);
    if (!filterPriceRangeSlider || !filterPriceRangeMin || !filterPriceRangeMax) return;
    filterPriceRangeSlider.addEventListener('input', function (event) {
      var _event$detail = event.detail,
          valueMin = _event$detail.valueMin,
          valueMax = _event$detail.valueMax;
      filterPriceRangeMin.value = valueMin;
      filterPriceRangeMax.value = valueMax;
    });
    filterPriceRangeSlider.addEventListener('change', function () {
      if (collectionNavbar.requestSubmit) {
        return collectionNavbar.requestSubmit();
      }

      var submitButton = collectionNavbar.querySelector('[type="submit"]');
      if (!submitButton) return;
      submitButton.click();
    });
  }
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ResultsFilterSort);

/***/ }),

/***/ 257:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _components_results_filter_sort__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(204);
var _window$Shopify, _window$Shopify$theme, _window$Shopify$theme2;



var sectionType = 'main-search';
var registeredSections = ((_window$Shopify = window.Shopify) === null || _window$Shopify === void 0 ? void 0 : (_window$Shopify$theme = _window$Shopify.theme) === null || _window$Shopify$theme === void 0 ? void 0 : (_window$Shopify$theme2 = _window$Shopify$theme.sections) === null || _window$Shopify$theme2 === void 0 ? void 0 : _window$Shopify$theme2.registered) || {};
var isUnregistered = typeof registeredSections[sectionType] === 'undefined';
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (isUnregistered && (0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.register)(sectionType, {
  onLoad: function onLoad() {
    (0,_components_results_filter_sort__WEBPACK_IMPORTED_MODULE_1__.default)(this.container, this.id);
  }
}));

/***/ }),

/***/ 196:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "debounce": () => (/* binding */ debounce)
/* harmony export */ });
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(177);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0__);

var debounce = function debounce(callback) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
  var timeoutId;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timeoutId);
    timeoutId = setTimeout(function () {
      timeoutId = null;
      callback.apply(void 0, args);
    }, delay);
  };
};

/***/ }),

/***/ 213:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "filterSearchParams": () => (/* binding */ filterSearchParams)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(132);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(208);
/* harmony import */ var core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(209);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(214);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(137);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(138);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(139);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(123);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(142);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(146);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(147);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(124);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(148);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_14__);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

















function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var filterSearchParams = function filterSearchParams(searchParams) {
  var keyValuePairsToRemove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var paramsToRemove = [];

  var _iterator = _createForOfIteratorHelper(searchParams),
      _step;

  try {
    var _loop = function _loop() {
      var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          value = _step$value[1];

      var removeKey = keyValuePairsToRemove.some(function (pair) {
        return pair.key === key && pair.value === value;
      });
      if (value === '' || removeKey) paramsToRemove.push(key);
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  paramsToRemove.forEach(function (key) {
    return searchParams["delete"](key);
  });
  return searchParams.toString();
};

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			28: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) var result = runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkbibendum"] = self["webpackChunkbibendum"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [37], () => (__webpack_require__(257)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;